import { Controller } from "@hotwired/stimulus";
import L from "leaflet";
import { MARKER_ICON_OPTIONS } from "../islands/SearchMapIsland";
import { DEFAULT_TILE_URL, removeLeafletPrefix, tileAttribution } from "../map_attribution";

// Single-pin neighborhood map for the listing pages (SUR-2302 / SSD-19).
// Server renders an empty container with data-lat/lng/tile-url/label; this
// controller mounts a non-interactive-by-default Leaflet map centered on the
// listing. Leaflet + its CSS are already part of every Connect page (the
// Custom Search island), so this adds no new dependencies.
export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
    tileUrl: String,
    label: String,
  };

  connect() {
    if (!this.latValue || !this.lngValue) return;

    this.map = L.map(this.element, {
      center: [this.latValue, this.lngValue],
      zoom: 14,
      scrollWheelZoom: false, // don't hijack page scroll
      attributionControl: true,
    });
    // Keep the control (the tile provider's credit is required) but drop
    // Leaflet's own flag + link — BSD-2-Clause, notice retained in
    // docs/third-party-notices.md.
    removeLeafletPrefix(this.map);
    L.tileLayer(this.tileUrlValue || DEFAULT_TILE_URL, {
      maxZoom: 19,
      attribution: tileAttribution(),
    }).addTo(this.map);

    const marker = L.marker([this.latValue, this.lngValue], { icon: L.icon(MARKER_ICON_OPTIONS) }).addTo(this.map);
    if (this.labelValue) marker.bindPopup(this.labelValue);
  }

  disconnect() {
    if (this.map) this.map.remove();
  }
}
